// Amplitude event taxonomy — canonical event names, property keys, and runtime validation.

/** Minimal Amplitude event shape for plugin use (avoids importing internal SDK types). */
export interface AmplitudeEvent {
  event_type: string;
  event_properties?: Record<string, unknown>;
  [key: string]: unknown;
}

/** Valid Amplitude event names for gaia. */
export type AmplitudeEventName = 'Beta UI Reverted';

/** Allowed properties per event. */
export interface AmplitudeEventPropertyMap {
  'Beta UI Reverted': { 'Current Route'?: string };
}

/** Enrichment properties auto-attached to every event. */
export interface AmplitudeEnrichmentProperties {
  Organization?: string;
  Agent?: string;
}

/** User properties set via Amplitude Identify. */
export interface AmplitudeUserProperties {
  UUID?: string;
  'Display Name'?: string;
  Email?: string;
}

// --------------- Runtime validation sets ---------------

export const EVENTS: Set<string> = new Set<AmplitudeEventName>(['Beta UI Reverted']);

export const PROPERTIES: Record<string, Set<string>> = {
  'Beta UI Reverted': new Set(['Current Route']),
};
